<template>
  <div id="contenedor-agregar-nuevo-presupuesto-detalle">
    <v-form v-model="formPptoDetalleValido">
      <v-row v-for="(detalle, i) in detalles" :key="`detalle-${i}`">
        <v-col cols="12" class="py-1">
          <v-card
            flat
            color="indigo lighten-5"
            class="rounded-lg">
            <v-card-subtitle class="py-0 pr-1">
              <v-row justify="end">
                <v-btn
                  icon
                  @click="removerDetalle(i)">
                  <v-icon class="secondary--text">close</v-icon>
                </v-btn>
              </v-row>
            </v-card-subtitle>
            <v-card-text class="pa-1 pt-0">
              <v-row justify="center" align="center" class="mt-n3">
                <custom-autocomplete
                  cols="12" md="5"
                  v-model="detalle.idObra"
                  label="Obra*"
                  :items="obras"
                  item-text="meta"
                  item-value="id"
                  :rules="[mixReglas.requerido]"
                  required>
                </custom-autocomplete>
                <custom-text-field
                  cols="12" md="4"
                  v-model="detalle.claveObra"
                  label="Clave Obra*"
                  :rules="[mixReglas.requerido]">
                </custom-text-field>
                <custom-text-field-green
                  v-if="!presupuestoCerrado"
                  cols="12" md="3"
                  v-model.number="detalle.importe"
                  label="Autorizado*"
                  prefix="$"
                  :value="0"
                  :rules="[mixReglas.notNull]"
                  type="number">
                </custom-text-field-green>
              </v-row>
              <!-- <v-row v-if="editarPresupuesto" justify="center">
                <v-col cols="auto" class="pt-0">
                  <v-checkbox
                    v-model="detalle.esPresupuestoOriginal"
                    label="Presupuesto Original"
                    hide-details
                    class="mt-0">
                  </v-checkbox>
                </v-col>
              </v-row> -->
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row justify="end">
        <v-btn
          color="secondary"
          dark
          class="rounded-l-xl"
          @click="agregarDetalle">
          Agregar Detalle
          <v-icon right>add</v-icon>
        </v-btn>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomTextFieldGreen from '@/components/inputs/TextFieldGreen.vue';
import CustomAutocomplete from '@/components/inputs/Autocomplete.vue';
// import CustomTextArea from '@/components/inputs/TextArea.vue';
// import CustomDatePicker from '@/components/inputs/DatePicker.vue';
// import CustomButton from '@/components/buttons/Button.vue';
import mixPresupuestosDetalles from './mixPresupuestosDetalles';

export default {
  name: 'NuevoPresupuestoDetalle',
  mixins: [mixPresupuestosDetalles],
  inheritAttrs: false,
  components: {
    CustomTextField,
    CustomTextFieldGreen,
    CustomAutocomplete,
    // CustomTextArea,
    // CustomDatePicker,
    // CustomButton,
  },
  props: {
    detalles: Array,
    value: {
      type: Boolean,
      default() {
        return this.value || null;
      },
    },
    presupuestoId: String,
    editarPresupuesto: Boolean,
  },
  data() {
    return {
      // idPresupuesto: ID!,
      //   idObra: ID!,
      //   claveObra: String,
      //   importe: Float!,
      //   esPresupuestoOriginal: Boolean!,
    };
  },
  methods: {
    agregarDetalle() {
      const detalle = {
        idObra: '', // ID!,
        claveObra: '', // String,
        importe: 0, // Float!,
      };
      if (this.editarPresupuesto) {
        detalle.idPresupuesto = this.presupuestoId;
      }
      if (this.presupuestoCerrado) {
        detalle.esPresupuestoOriginal = false;
      } else {
        detalle.esPresupuestoOriginal = true;
      }
      this.detalles.push(detalle);
    },
    removerDetalle(i) {
      this.detalles.splice(i, 1);
    },
  },
  computed: {
    presupuestoCerrado() {
      return this.getPresupuesto.esPresupuestoOriginal;
    },
    formPptoDetalleValido: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>
